//////////////////////////////////////////////////////////////////////
//
//  09/28/18
//  src/containers/MainFull.js
//
//  This file is the top level MainFull javascript file.
//

import React, { Component } from 'react';
import { IRH_myModal } from "../components/IconRowHelp";
import FullBlk   from "../components/FullBlk";
import BarData   from "../components/BarData";
import RestData  from "../components/RestData";
import MusicData from "../components/MusicData";
import GrillData from "../components/GrillData";
import './MainFull.css';

class MainFull extends Component {
  render() {
    const { navbar } = this.props;
    const bIdx = 10;
    console.log( "MainFull Props.navbar.sCat: " + navbar.sCat );

    var title = "";
    var xdata = {};

    switch( navbar.sCat ) {
    case 'bars':   xdata = this.formatData( BarData,   bIdx );    title="Bars";               break;
    case 'rests':  xdata = this.formatData( RestData,  bIdx );    title="Restaurants";        break;
    case 'music':  xdata = this.formatData( MusicData, bIdx );    title="Music";              break;
    default:       xdata = this.formatData( GrillData, bIdx );    title="Bar and Grills";     break;
    }

    return (
      <div id="MainFullTop">
        <div id="MainFullTitle">{ title }</div>
        <div id="MainFullBody">{ xdata }</div>
        
        <div id={ 'myModal' }  style={ IRH_myModal }>
        </div>

      </div>
    );
  }

  //
  //  Format the data to layout on the screen
  //
  formatData( cData, rNum ) {
    var tmpData = cData.map( ( val, idx ) => {
      //console.log( "Index: " + ( idx + bIdx ) + ", Name: " + val.name ); 
        return( 
          <FullBlk 
            key = { idx } 
            miles={ val.miles } 
            name ={ val.name  } 
            row  ={ idx+rNum  } 
            music={ val.music }
            food ={ val.food  }
            happy={ val.happy }
            notes={ val.notes }
            board={ val.board }
            line1={ val.line1 }
            line2={ val.line2 }
            line3={ val.line3 }
            line4={ val.line4 }
            mpop ={ val.mpop  }
            fpop ={ val.fpop  }
            hpop ={ val.hpop  }
            addr ={ val.addr  }
          />
        );
      });
    return tmpData;
  }
}

export default MainFull;



// WEBPACK FOOTER //
// ./src/containers/MainFull.js